import { atom } from 'jotai';
import { loadable } from 'jotai/utils';
import { fetchTrophies } from '../api/tournament';

// Async atom — fetches trophies on first read
const trophiesFetchAtom = atom(async () => {
    const data = await fetchTrophies();
    return data;
});

const trophiesLoadableAtom = loadable(trophiesFetchAtom);

// Self-loading, read-only. Returns [] while loading.
// Mixed array of tournament + playoff trophies, sorted by date (newest first)
export const userTrophiesAtom = atom((get) => {
    const fetched = get(trophiesLoadableAtom);
    return fetched.state === 'hasData' ? fetched.data : [];
});
